import React,{useContext,useState,useEffect} from 'react';
import { styled } from '@mui/material/styles';
import { useHistory } from "react-router-dom";
import {useTranslation} from 'react-i18next';

import clsx from 'clsx';
import {
  AppBar,
  Typography,
  Backdrop,
  CircularProgress,
  Grid,
  Tabs,
  Tab,
  Paper,
  Button,
} from '@mui/material';

import TableContainerComponent from './Common/TableContainerComponent';
import TabPanel from './Common/DashboardTabPanel';
import Header from '../CommonComponents/Header';
import Footer from '../CommonComponents/Footer';
import ProjectsDrawer from './Common/ProjectsDrawer';
import SummaryDrawer from './Common/SummaryDrawer';
import BypassBlocks from '../CommonComponents/BypassBlocks';
import {DRAWER_WIDTH} from './Common/ProjectsDrawer';
import FloatingSupportButton from '../CommonComponents/Support';
import Snackbar from '../CommonComponents/Snackbar';

import {Auth} from '../../Api/auth';
import {defaultRequestsInfoValues} from "../../StateObjects/RequestsInfoContext";
import {ProjectInfoContext} from '../../StateObjects/ProjectInfoContext';
import {RequestStatusId, RequestActionId} from '../../ApplicationConfig/constants';
import {useStateWithLocalStorage} from '../../Api/functions';
import {DialogNewRequestTitle} from '../CommonComponents/DialogBox';
import {REQUEST_FORM_DEFAULTS} from '../../StateObjects/requestFormDefaults';
import { useMsal } from '@azure/msal-react';

const PREFIX = 'DashboardPageResearcher';

const classes = {
  container: `${PREFIX}-container`,
  main: `${PREFIX}-main`,
  appBar: `${PREFIX}-appBar`,
  appBarHeader: `${PREFIX}-appBarHeader`,
  content: `${PREFIX}-content`,
  contentShift: `${PREFIX}-contentShift`,
  tabs: `${PREFIX}-tabs`,
  tabPanel: `${PREFIX}-tabPanel`,
  gridDetails: `${PREFIX}-gridDetails`,
  requestFormHeader: `${PREFIX}-requestFormHeader`,
  title: `${PREFIX}-title`,
  backdrop: `${PREFIX}-backdrop`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`&.${classes.container}`]: {
    display: 'flex',
    minHeight: '100vh',
    flexDirection: 'column',
  },

  [`& .${classes.main}`]: {
    background: theme.palette.grey[100],
    flex: 1,
  },

  [`& .${classes.appBar}`]: {
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.common.white,
    width: '100%',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },

  [`& .${classes.appBarHeader}`]: {
    color: theme.palette.text.primary,
    background: 'white',
    position: 'static',
    top: 0,
    left: 'auto',
    width: '100%',
    padding: theme.spacing(2, 1, 1, '!important'),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },

  [`& .${classes.content}`]: {
    boxSizing: 'border-box',
    background: theme.palette.grey[100],
    padding: theme.spacing(3),
    flexGrow: 1,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: 0,
  },

  [`& .${classes.contentShift}`]: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: DRAWER_WIDTH,
  },

  [`& .${classes.tabs}`]: {
    'borderBottom': '1px solid',
    'borderBottomColor': theme.palette.grey[300],
    '& .MuiTabScrollButton-root.Mui-disabled': {
      display: 'none',
    },
  },

  [`& .${classes.tabPanel}`]: {
    '& .MuiBox-root': {
      width: '100%',
      padding: 0,
      boxSizing: 'border-box',
      overflowY: 'auto',
      boxShadow: theme.shadows[4],
    },
  },

  [`& .${classes.gridDetails}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'flex-start',
      marginTop: theme.spacing(3),
    },
  },

  [`& .${classes.requestFormHeader}`]: {
    display: 'flex',
    flexFlow: 'row',
    alignItems: 'start',
    [theme.breakpoints.down('md')]: {
      flexFlow: 'column',
    },
  },

  [`& .${classes.title}`]: {
    flexGrow: 1,
  },

  [`& .${classes.backdrop}`]: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  }
}));

const HeadCells = ()=>{
  const {t,i18n} = useTranslation();

  return [
    {id: 'identifier', narrow: false, disablePadding: true, disableSorting: false, label: t('researcherDashboard.tableHeader.request')},
    {id: 'statusDesc' + i18n.language.toUpperCase(), narrow: false, disablePadding: false, disableSorting: false, label: t('researcherDashboard.tableHeader.status')},
    {id: 'researcherFullName', narrow: false, disablePadding: false, disableSorting: false, label: t('researcherDashboard.tableHeader.researcher')}, // not sorting
    {id: 'primaryAnalystFullName', narrow: false, disablePadding: false, disableSorting: false, label: t('researcherDashboard.tableHeader.analyst')},
    {id: 'createdOn', narrow: false, disablePadding: false, disableSorting: false, label: t('researcherDashboard.tableHeader.createdOn')}, // not sorting
    {id: 'updatedOn', narrow: false, disablePadding: false, disableSorting: false, label: t('researcherDashboard.tableHeader.updatedOn')},
    {id: 'actions', narrow: true, disablePadding: false, disableSorting: true, label: 'Actions'},
  ];
}

function a11yProps(index) {
  return {
    'id': `dashboard-tab-${index}`,
    'aria-controls': `dashboard-tabpanel-${index}`,
  };
}

export default function DashboardPageResearcher() {
  const history = useHistory();
  const {t, i18n} = useTranslation();
  const {instance}=useMsal();


  const [value, setValue] = React.useState(0);
  const [open, setOpen] = React.useState({
    projectsDrawer: true,
    summaryDrawer: false,
    summaryData:undefined,
    newRequest:false
  });
  const [foldersList, setFoldersList] = React.useState([]);
  const [loadingFolders, setLoadingFolders] = React.useState({loading: false, failed: false, project: -1});

  const [backdropOpen, setBackdropOpen] = React.useState(false);
  
  const {projectInfo} = useContext(ProjectInfoContext);

  const [snackbarState, setSnackbarState] = React.useState({
    open: false,
    severity: "success",
    message: ""
  });

  const [requestsInfo, setRequestsInfo] = React.useState({rows: [], maxRows: 0});

  const getPageRequestData=(silentRefresh=false, tab, page, rowsPerPage, orderBy, order)=>{
    if(projectInfo.id===-1){
      return;
    }
    if (!silentRefresh){
      setBackdropOpen(true);
    }
    
    let urlParams = new URLSearchParams({"tab": tab, "page": page+1, "perPage": rowsPerPage, "sortColumn": orderBy, "sortOrder": order});
    Auth.authorizedFetch("/api/getPageRequests/" + projectInfo.id + "?" + urlParams.toString(),{},instance)
    .then(res => res.json())
    .then((result)=>{
      if (!silentRefresh && result.statusCode!=200){
        setSnackbarState({open: true, severity: "error", message: t("applicationErrorMessage.request." + result.customMessageKey)});
      } else if (result.statusCode==200){
        setRequestsInfo({rows:result.data.requestList, maxRows:result.data.maxRequests});
      }
    })
    .catch((error)=>{
      console.log(error);
      if (!silentRefresh){
        setSnackbarState({open: true, severity: "error", message: t("applicationErrorMessage.generic.dataError")});
      }
    })
    .finally(()=>{
      setBackdropOpen(false);
    });

    //TODO: check if a page change is required in case the user deleted all rows on a page
  }

  const handleSupportSubmit=()=>{

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({project_id: projectInfo.id})
    };

    //API CALL to send e-mail
    Auth.authorizedFetch("/api/requestGenericHelp",requestOptions,instance)
    .then(res => res.json())
    .then((result) => {
      if (result.statusCode!=200){
        setSnackbarState({open: true, severity: "error", message: t("applicationErrorMessage.generic.unexpectedError")});
      } else if (result.statusCode==200){
        setSnackbarState({open: true, severity: "success", message: t("notifications.vettingRequestHelpRequested")});
      }
    })
    .catch((error)=>{
      console.log(error)
      setSnackbarState({open: true, severity: "error", message: t("applicationErrorMessage.generic.unexpectedError")});
    })
    
  }

  const getFoldersList=(filesData, path, depth)=>{
    let list = [];
    if(depth<=0){
      return list;
    }
    Object.keys(filesData).map(k=>{
      let newPath = path+k;
      list.push(newPath);
      list = list.concat(getFoldersList(filesData[k]["sub_dirs"], newPath+"/", depth-1));
    });
    return list;
  }

  useEffect(()=>{
    if(!loadingFolders.loading && loadingFolders.failed && open.newRequest){
      setSnackbarState({open: true, severity: "error", message: t("applicationErrorMessage.generic.dataError")});
      toggleDialog('newRequest', false);
    }
  }, [loadingFolders, open]);
  
  useEffect(() => {
    if(open.newRequest && projectInfo.id !== loadingFolders.project){
      setLoadingFolders({loading: true, failed: false, project: projectInfo.id});
      
      Auth.authorizedFetch("/api/getStorageAccountFolders/"+projectInfo.id,{},instance)
      .then(res=>res.json())
      .then((result)=>{
        if(result.statusCode===200){
          let foldersList = getFoldersList(result.data, "", 2);

          let rootIndex=foldersList.indexOf("Vetting Requests-Demandes de contrôle");
          if(rootIndex>=0){
            foldersList.splice(rootIndex, 1);
          }
          
          setFoldersList(foldersList);
          setLoadingFolders({...loadingFolders, loading: false, failed: false, project: projectInfo.id});
        }else{
          setLoadingFolders({...loadingFolders, loading: false, failed: true, project: projectInfo.id});
        }
      })
      .catch((e)=>{
        console.log(e);
        setLoadingFolders({...loadingFolders, loading: false, failed: true, project: projectInfo.id});
      });
    }
  }, [projectInfo.id, open.newRequest]);

  const toggleProjectsDrawer = () => {
    setOpen({...open, projectsDrawer: !open.projectsDrawer});
  };

  const toggleSummaryDrawer = (event,row) => {
    if (row==undefined){
      row=open.summaryData
    }
    setOpen({...open, summaryDrawer: !open.summaryDrawer,summaryData:row});
  };

  const toggleDialog = (state, value) => {
    setOpen({...open, [state]: value});
  };

  const handleNewRequestSubmission=(newRequestState)=>{
    let defaultValues = {...REQUEST_FORM_DEFAULTS};
    defaultValues.requestName=newRequestState.name;
    defaultValues.outputFilesFolder=newRequestState.folder;

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({formData: defaultValues, project: projectInfo})
    };
    Auth.authorizedFetch("/api/createNewRequest", requestOptions,instance)
    .then(res=> res.json())
    .then(data => {
      if(data.statusCode === 200){
        history.push("/"+i18n.language+"/request/"+data.data.newRequestId, {newRequest: true});
      }else{
        if(Object.prototype.hasOwnProperty.call(data, "customMessageKey")){
          setSnackbarState({open: true, severity: "error", message: t("applicationErrorMessage.request." + data.customMessageKey)});
        }else{
          setSnackbarState({open: true, severity: "error", message: t("applicationErrorMessage.request.submitError")});
        }
      }
    })
    .catch(()=>{
      setSnackbarState({open: true, severity: "error", message: t("applicationErrorMessage.request.submitError")});
    });
  }

  const summaryViewRequestClickHandler=(requestId)=>{
    history.push("/" + i18n.language + "/request/"+ requestId);
  }
  
  const toggleDialogNewRequest = ()=>{
    toggleDialog('newRequest', true);
  }

  const mainRef = React.createRef();
  const footerRef = React.createRef();

  React.useEffect(()=>{
    document.title=t('researcherDashboard.title');
  }, [i18n.language]);

  React.useEffect(()=>{
    if(history.location.state && history.location.state.snackbar){
      setSnackbarState({
        severity: history.location.state.snackbar.severity,
        message: history.location.state.snackbar.message,
        open: true
      });
    }
  }, []);

  return (
    <Root className={classes.container}>
      <BypassBlocks ref={{main: mainRef, footer: footerRef}} />
      <Header 
        clickHandler={toggleProjectsDrawer}
        source="dashboard"
        handleSupportSubmit={handleSupportSubmit}
        open={open.projectsDrawer}
      />
      <ProjectsDrawer
        open={open.projectsDrawer}
      />
      <main className={classes.main}>
        <Paper
          className={clsx(classes.content, classes.paper, {
            [classes.contentShift]: open.projectsDrawer,
          })}
          elevation={0}
        >
          <SummaryDrawer
            open={open.summaryDrawer}
            clickHandler={toggleSummaryDrawer}
            data={open.summaryData}
            viewRequestClickHandler={summaryViewRequestClickHandler}
          />
          <AppBar
            position="static"
            component="div"
            className={classes.appBar}
            ref={mainRef} 
            tabIndex="-1"
          >
            <AppBar
              className={classes.appBarHeader}
              elevation={0}
            >
              <Grid container className={classes.requestFormHeader}>
                <Grid item className={classes.title}>
                  <Typography variant="h6" component="h2">
                    {projectInfo.contractNumber}
                  </Typography>
                </Grid>
                <Grid item className={classes.gridDetails}>
                    <Button 
                    id="newRequestButton"
                    variant="contained" 
                    color="primary" 
                  
                    onClick={toggleDialogNewRequest} 
                    disabled={projectInfo.id===-1}
                  >
                    {t('researcherDashboard.newVettingRequest')}
                  </Button>
                </Grid>
              </Grid>
            </AppBar>
            <Tabs
              value={value}
              onChange={(e, newValue)=>setValue(newValue)}
              aria-label={t('researcherDashboard.tabsLabel')}
              indicatorColor="primary"
              textColor="primary"
              className={classes.tabs}
              variant="scrollable"
              scrollButtons
              allowScrollButtonsMobile>
              <Tab label={t('researcherDashboard.tabs.active')} {...a11yProps(0)} />
              <Tab label={t('researcherDashboard.tabs.withdrawn')} {...a11yProps(1)} />
              <Tab label={t('researcherDashboard.tabs.approved')} {...a11yProps(2)} />
              <Tab label={t('researcherDashboard.tabs.denied')} {...a11yProps(3)} />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0} className={classes.tabPanel}>
            <TableContainerComponent
              setBackdropOpen={setBackdropOpen}
              contextSummaryClick={toggleSummaryDrawer}
              status="active"
              headCells={HeadCells} 
              statusHead={0}
              getPageRequestData={getPageRequestData}
              requestsInfo={requestsInfo}
              setRequestsInfo={setRequestsInfo}
            />
          </TabPanel>
          <TabPanel value={value} index={1} className={classes.tabPanel}>
            <TableContainerComponent 
              setBackdropOpen={setBackdropOpen}
              contextSummaryClick={toggleSummaryDrawer}
              status="withdrawn"
              headCells={HeadCells}
              statusHead={0}
              getPageRequestData={getPageRequestData}
              requestsInfo={requestsInfo}
              setRequestsInfo={setRequestsInfo}
            />
          </TabPanel>
          <TabPanel value={value} index={2} className={classes.tabPanel}>
            <TableContainerComponent 
              setBackdropOpen={setBackdropOpen}
              contextSummaryClick={toggleSummaryDrawer}
              status="approved"
              headCells={HeadCells}
              statusHead={RequestStatusId.Approved}
              getPageRequestData={getPageRequestData}
              requestsInfo={requestsInfo}
              setRequestsInfo={setRequestsInfo}
            />
          </TabPanel>
          <TabPanel value={value} index={3} className={classes.tabPanel}>
            <TableContainerComponent 
              setBackdropOpen={setBackdropOpen}
              contextSummaryClick={toggleSummaryDrawer}
              status="denied"
              headCells={HeadCells}
              statusHead={RequestStatusId.Denied}
              getPageRequestData={getPageRequestData}
              requestsInfo={requestsInfo}
              setRequestsInfo={setRequestsInfo}
            />
          </TabPanel>
        </Paper>
        <DialogNewRequestTitle
          open={open.newRequest && !loadingFolders.loading}
          toggleDialog={() => toggleDialog('newRequest', false)}
          handleRequestSubmission={handleNewRequestSubmission}
          foldersList={foldersList}
        />
        <FloatingSupportButton handleSupportSubmit={handleSupportSubmit} />

        <Backdrop className={classes.backdrop} open={backdropOpen || (open.newRequest && loadingFolders.loading)}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <Snackbar 
          message={snackbarState.message}
          severity={snackbarState.severity}
          open={snackbarState.open}
          handleClose={()=>{setSnackbarState({...snackbarState, open: false, message: ""})}}
        />
      </main>
      <Footer open={open.projectsDrawer} ref={footerRef}/>
    </Root>
  );
}
